import React from 'react';
import { Button } from 'antd';
import { CodeOutlined } from '@ant-design/icons';

import CompoundPreviewSummaryGridCell from '../../compound/execution/SummaryGridCell';
import { getClosingRangeText, isPerStepClosingRangeEnabled } from '../../../utils/compound';
import ConversionMenu from '../../../containers/funnel/execution/ConversionMenu';
import QueryExposureModal from '../../../containers/funnel/side/QueryExposureModal';
import isFunnelReadyToExecute from '../../../utils/funnel';
import CompoundSideActionButtons from '../../compound/side/ActionButtons';
import { divideIntoNumericDigits } from '../../../utils/common';

const FunnelExecutionSummaryGrid = ({
  item,
  started,
  preview,
  conversion,
  completed,
  optionalConversion,
  optionalCompleted,
  hasPermission,
  onUpdate,
  onDelete,
  onDuplicate,
  additionalStyle,
  showExposureSQLButton,
}) => {
  const renderButton = (onClick, updatingFunnel) => (
    <Button
      icon={<CodeOutlined />}
      style={{ border: 'none', backgroundColor: 'transparent' }}
      onClick={(e) => {
        onClick();
        e.target.blur();
      }}
      disabled={!isFunnelReadyToExecute(item, updatingFunnel)}
    />
  );

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        backgroundColor: 'rgb(247, 246, 244)',
      }}
    >
      <div style={{ flex: '1 1 auto' }}>
        <CompoundPreviewSummaryGridCell
          additionalStyle={additionalStyle}
          name={item.name}
          description={
            !isPerStepClosingRangeEnabled(item.closingRange)
              ? `Global closing range: ${getClosingRangeText(item.closingRange)}`
              : ''
          }
        >
          {preview && hasPermission && (
            <CompoundSideActionButtons
              item={item}
              onUpdate={onUpdate}
              onDelete={onDelete}
              onDuplicate={onDuplicate}
              additionalStyle={additionalStyle}
            >
              {showExposureSQLButton && <QueryExposureModal button={renderButton} />}
            </CompoundSideActionButtons>
          )}
        </CompoundPreviewSummaryGridCell>
        <ConversionMenu />
      </div>
      {!preview && (
        <>
          <CompoundPreviewSummaryGridCell
            value={divideIntoNumericDigits(started)}
            description="Users Started"
          />
          <CompoundPreviewSummaryGridCell
            value={
              <span>
                {conversion}%
                {optionalConversion != null ? (
                  <span className="funnel-optional-text"> ({optionalConversion}%)</span>
                ) : null}
              </span>
            }
            description="Conversion Rate"
          />
          <CompoundPreviewSummaryGridCell
            additionalStyle={{ padding: 15 }}
            value={
              <span>
                {divideIntoNumericDigits(completed)}
                {optionalCompleted != null ? (
                  <span className="funnel-optional-text">
                    {' '}
                    ({divideIntoNumericDigits(optionalCompleted)})
                  </span>
                ) : null}
              </span>
            }
            description="Users Completed"
          >
            {hasPermission && (
              <CompoundSideActionButtons
                item={item}
                onUpdate={onUpdate}
                onDelete={onDelete}
                onDuplicate={onDuplicate}
                additionalStyle={{ padding: 15 }}
              >
                {showExposureSQLButton && <QueryExposureModal button={renderButton} />}
              </CompoundSideActionButtons>
            )}
          </CompoundPreviewSummaryGridCell>
        </>
      )}
    </div>
  );
};

export default FunnelExecutionSummaryGrid;
